import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng';
import { OrganisationsService, UserService } from '../../../services';
import { IUserOrganisationLevel } from '../../../interfaces/user-organisation-level';
import { ITaskInfo } from '../../../interfaces/task-info';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-create-movement-department-team',
  templateUrl: './create-movement-department-team.component.html',
  styleUrls: ['./create-movement-department-team.component.scss'],
})
export class CreateMovementDepartmentTeamComponent implements OnInit {
  @Output() departmentChangeEvent = new EventEmitter();
  @Output() teamChangeEvent = new EventEmitter();
  @Input() taskInfo: ITaskInfo;

  departments: SelectItem[] = [];
  customerDepartmentId: any;
  teams: SelectItem[] = [];
  customerTeamId: any;
  confirmNotificationEntity: string;
  confirmNotificationTypes: any[] = [];
  teamChosen: any;
  departmentChosen: any;
  userOrgLevel: IUserOrganisationLevel;
  userOrg: any;
  isUserImpersonated: boolean;

  constructor(private orgService: OrganisationsService, private userService: UserService) {}

  ngOnInit(): void {
    this.orgService.getUserOrganisationLevel().then((level) => {
      this.userOrgLevel = level;

      this.orgService.getOrg(this.userOrgLevel.organisationId).then((org) => {
        this.userOrg = org;
        this.loadDepartments();

        if (this.taskInfo?.furtherInformation?.customerDepartmentId) {
          this.customerDepartmentId = this.taskInfo.furtherInformation.customerDepartmentId;
        } else if (this.userOrgLevel.defaultDepartmentId) {
          this.customerDepartmentId = this.userOrgLevel.defaultDepartmentId;
        } else if (
          this.userOrgLevel.teamId.length == 1 &&
          this.userOrgLevel.departmentId.length == 1
        ) {
          this.customerDepartmentId = this.userOrgLevel.departmentId[0];
        }

        this.departmentChangeEvent.emit(this.customerDepartmentId);

        // Teams
        var promise = this.loadTeams(this.customerDepartmentId);
        if (promise) {
          promise.then(() => {
            if (this.taskInfo?.furtherInformation?.customerTeamId) {
              this.customerTeamId = this.taskInfo.furtherInformation.customerTeamId;
            } else if (this.userOrgLevel.defaultTeamId) {
              this.customerTeamId = this.userOrgLevel.defaultTeamId;
            } else if (
              this.userOrgLevel.teamId.length == 1 &&
              this.userOrgLevel.departmentId.length == 1
            ) {
              this.customerTeamId = this.userOrgLevel.teamId[0].id;
            }

            this.teamChangeEvent.emit(this.customerTeamId);
          });
        }

        // TODO !! DO WE NEED THIS ??
        //  this.loadChargingFees();
      });
    });

    this.isUserImpersonating();
  }

  teamChange(event) {
    this.confirmNotificationEntity = 'Team';
    this.confirmNotificationTypes = [];

    if (event?.value) {
      // Does this Team have pickup/dropoff notifications set ?
      this.orgService.getTeam(event.value).then((response) => {
        this.teamChosen = response;
      });

      this.teamChangeEvent.emit(event.value);
    } else {
      this.teamChangeEvent.emit(null);
    }
  }

  departmentChange(event) {
    this.customerTeamId = null;

    this.teamChangeEvent.emit(null);

    this.loadTeams(event.value).then(() => {
      this.confirmNotificationEntity = 'Department';
      this.confirmNotificationTypes = [];

      if (event.value) {
        this.departmentChangeEvent.emit(event.value);
      } else {
        this.departmentChangeEvent.emit(null);
      }
    });
  }

  loadTeams(departmentId: number): Promise<any> {
    this.teams = [];
    this.teams.push({ label: 'Select Team...', value: null });

    if (this.customerDepartmentId != null) {
      return this.orgService.getDepartment(this.customerDepartmentId).then((data) => {
        this.departmentChosen = data;

        if (data != null) {
          var allTeams = [];
          if (this.userOrgLevel.teamId.filter((x) => x.isAll).length != 0) {
            allTeams = data.teams;
          } else if (this.userOrgLevel.teamId.filter((x) => x.id).length != 0) {
            allTeams = data.teams.filter(
              (x: any) => this.userOrgLevel.teamId.filter((t) => t.id == x.id).length != 0,
            );
          }

          allTeams.sort(this.compareItem);
          allTeams.forEach((t) => {
            this.teams.push({ label: t.name, value: t.id });
          });

          if (this.taskInfo?.furtherInformation?.customerTeamId) {
            this.customerTeamId = this.taskInfo.furtherInformation.customerTeamId;
          } else if (
            this.userOrgLevel.teamId.length == 1 &&
            this.userOrgLevel.departmentId.length == 1
          ) {
            this.customerTeamId = this.userOrgLevel.teamId[0].id;
          }
        }
      });
    }

    return Promise.resolve();
  }

  loadDepartments() {
    var allDepartments = [];
    if (this.userOrgLevel.teamId.filter((x) => x.isAll).length != 0) {
      allDepartments = this.userOrg.departments;
    } else if (this.userOrgLevel.teamId.filter((x) => x.id).length != 0) {
      allDepartments = this.userOrg.departments.filter(
        (x) => this.userOrgLevel.departmentId.indexOf(x.id) > -1,
      );
    }

    this.departments = [];
    allDepartments.sort(this.compareItem);
    allDepartments.forEach((d) => {
      this.departments.push({ label: d.name, value: d.id });
    });
    //this.departments.sort(this.compareSelectItem);
    this.departments.unshift({ label: 'Select Department...', value: null });
  }

  compareItem(x: any, y: any) {
    if (x.name.toLowerCase() > y.name.toLowerCase()) return 1;
    else if (x.name.toLowerCase() < y.name.toLowerCase()) return -1;
    else return 0;
  }

  isUserImpersonating() {
    this.userService
      .isUserImpersonating()
      .then((res) => {
        var resultData: any;
        resultData = res;
        if (resultData != null) {
          this.isUserImpersonated = resultData.isImpersonating;
        } else {
          this.isUserImpersonated = false;
        }
      })
      .catch((errorResponse: HttpErrorResponse) => {
        console.log(errorResponse.message);
      });
  }
}
